module.exports = __webpack_public_path__ + "img/greeting.c8b7b669.webp";